
export const userKeyStorage = '_user_gogogo'
export const userTokenStorage = '_user_token_gogogo'
export const userIdStorage = '_user_id_gogogo'
export const userAdminStorage = '_user_admin_gogogo'
export const notificationStorage = '_notification_gogogo'
